const actionListCssModulesFlag = 'primer_react_css_modules_ga';

export { actionListCssModulesFlag };
